import {registerRoute as workbox_routing_registerRoute} from '/vercel/path0/node_modules/workbox-routing/registerRoute.mjs';
import {NetworkOnly as workbox_strategies_NetworkOnly} from '/vercel/path0/node_modules/workbox-strategies/NetworkOnly.mjs';
import {clientsClaim as workbox_core_clientsClaim} from '/vercel/path0/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from '/vercel/path0/node_modules/workbox-precaching/precacheAndRoute.mjs';
import {cleanupOutdatedCaches as workbox_precaching_cleanupOutdatedCaches} from '/vercel/path0/node_modules/workbox-precaching/cleanupOutdatedCaches.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */


importScripts(
  "fallback-QEaPDTE8UcwV8YNZ7-jYo.js"
);







self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "/static/offline.html",
    "revision": "QEaPDTE8UcwV8YNZ7-jYo"
  }
], {
  "ignoreURLParametersMatching": []
});
workbox_precaching_cleanupOutdatedCaches();



workbox_routing_registerRoute(({ request }) => request.mode === 'navigate', new workbox_strategies_NetworkOnly({ plugins: [{ handlerDidError: async ({ request }) => self.fallback(request) }] }), 'GET');




